<template>
  <div>
    <div class="notifications">
      <notification
        horizontalAlign="center"
        v-if="alert.message"
        icon='tim-icons icon-bell-55'
        :message="alert.message"
        :type="alert.type"
        @close="clearAlert"
      >
      </notification>
    </div>
    <router-view></router-view>
  </div>
</template>



<script>
import Notification from '@/components/NotificationPlugin/Notification.vue';

import { mapState, mapActions } from 'vuex';


export default {
  name: 'app',
  components: {
    Notification
  },
  computed: {
    ...mapState({
      alert: state => state.alert,
      user: state => state.user,
    })
  },
  methods: {
    ...mapActions({
      clearAlert: 'alert/clear',
    },{
      root:true
    })
  },
  mounted() {
    this.clearAlert();
    console.log(this.$store.state.user);
    if (this.$store.state.user === false){
      this.$router.push('login');
    }
  },watch: {
      $route (to, from){
        // clear alert on location change
        this.clearAlert();
      },
      alert: {
        immediate: true,
        // deep: false,
        handler(newValue, oldValue) {
          // console.log(newValue);
        }
      }
    } 
};
</script>
